import { Checkbox } from '@chakra-ui/react'

import { useFormContext } from '@redwoodjs/forms'

// Honey-pot https://stackoverflow.com/questions/36227376/better-honeypot-implementation-form-anti-spa
const HoneyPot = () => {
  const { register } = useFormContext()

  return (
    <Checkbox
      tabIndex={-1}
      style={{
        zIndex: -1,
        position: 'fixed',
        top: 0,
        left: 0,
        opacity: 0,
        pointerEvents: 'none',
      }}
      h={0}
      w={0}
      autoComplete="off"
      type="checkbox"
      name="contactmebyfaxonlyrequired"
      {...register('contactmebyfaxonlyrequired')}
      value="1"
    >
      Contact me by fax
    </Checkbox>
  )
}

export default HoneyPot
